export const contactHero = {
  title: '联系我们',
  subtitle: 'CONTACT US',
  description: '无论您是关注健康管理的顾客，还是寻找合作机会的伙伴，我们都期待与您取得联系。',
};

export const contactInfo = {
  company: '麦杰集团',
  brand: '颜轻至',
  phone: '400-888-6688',
  email: 'contact@yanqingzhi.com',
  address: '陕西省西安市雁塔区科技路XX号',
  workingHours: '周一至周日 09:00 - 21:00',
};

export const mapInfo = {
  address: '西安市未央区未央路武警小区南楼（恒佳首座东）',
  phone: '400-888-6688',
  workingHours: '周一至周日 09:00 - 21:00',
};

export const entranceCards = [
  {
    id: 'customer',
    title: '顾客咨询',
    subtitle: 'CUSTOMER SERVICE',
    description: '了解健康纤体方案、预约门店体验、咨询个性化服务',
    icon: 'ri-user-heart-line',
    cta: '在线咨询',
    features: ['免费体测评估', '个性化方案咨询', '门店预约体验', '健康知识分享'],
  },
  {
    id: 'franchise',
    title: '招商加盟咨询',
    subtitle: 'FRANCHISE INQUIRY',
    description: '了解加盟模式、区域合作政策、获取招商资料',
    icon: 'ri-briefcase-line',
    cta: '申请加盟',
    features: ['招商政策解读', '区域保护机制', '投资回报分析', '门店考察安排'],
  },
];

export const trustInfo = [
  { icon: 'ri-building-2-line', title: '十余年行业积淀', desc: '深耕健康体重管理领域' },
  { icon: 'ri-earth-line', title: '多省市场网络', desc: '覆盖8+省份核心城市' },
  { icon: 'ri-team-line', title: '专业顾问服务', desc: '系统化培训认证团队' },
  { icon: 'ri-shield-check-line', title: '总部培训支持', desc: '全周期运营扶持体系' },
];